import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function NotFound() {
  return (
    <>
      <h1 className="text-2xl font-bold mb-4 text-white">No encontrada</h1>
      <p className="text-white text-justify">
        La página que estás buscando no existe o ha sido movida. Por favor,
        verifica la URL o vuelve a la página de inicio.
      </p>
      <div className="mt-4">
        <FontAwesomeIcon
          icon="fa-solid fa-exclamation-triangle"
          className="text-3xl text-blue-500"
        />
      </div>
    </>
  );
}
